/**
 * This is the changepassword controller.
 * @memberOf changepassword Module
 * @namespace changepassword Controller
 */

/**
 * @name changepasswordController
 * @desc Create the controller.
 * @param coreService
 * @memberOf changepassword Module.changepassword Controller
 * @ngInject
 */
function changepasswordController($translate, coreService, $window, $log) {
    // Assign this controller as the view-model.
    var vm = this;
  
   // Assign this controller as the view-model.
   var minPattern;
   var lowercasePattern = new RegExp("[a-z]+");
   var uppercasePattern = new RegExp("[A-Z]+");
   var numericPattern = new RegExp("[0-9]+");
   var specialCharacterPattern = new RegExp("[\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@@\^\_\`\{\|\}\~\]+");
   vm.newPasswordBlur = newPasswordBlur;
   vm.validateRules = validateRules;
   vm.confirmPasswordBlur = confirmPasswordBlur;
   vm.hasRegExError = false;
   vm.hasConfirmPasswordError = false;
   vm.tempNewPasswordValue = '';

   // Activate the controller.
   activate();

   // Activates the controller.
   function activate() {
       
    // Read Identity Server's data model
    var model = coreService.getIdentityModel();
    vm.model = model;

    // Change display language
    if (model && model.ui_locales) {
      $translate.preferredLanguage(model.ui_locales);
    }

    $translate(['changepassword.form.title', 'changepassword.form.instruction', 'changepassword.form.validaterule_instruction', 
     'changepassword.form.validaterule_has_lower_case', 'changepassword.form.validaterule_has_upper_case',
     'changepassword.form.validaterule_has_min_length', 
     'changepassword.form.validaterule_has_numeric', 
     'changepassword.form.validaterule_has_special_characters', 'changepassword.messages.validate_error_invalid_confirm_password',
     'changepassword.messages.validate_error_lower_case', 'changepassword.messages.validate_error_upper_case',
     'changepassword.messages.validate_error_special_char', 'changepassword.messages.validate_error_numeric',
     'changepassword.messages.validate_error_min_char']) 
      .then(function(data) {
            vm.data = data;   
            vm.data['changepassword.form.validaterule_has_min_length'] = vm.data['changepassword.form.validaterule_has_min_length'].replace('[min_char]', vm.model.minLength);
            vm.data['changepassword.messages.validate_error_min_char'] = vm.data['changepassword.messages.validate_error_min_char'].replace('[min_char]', vm.model.minLength);
            var minPatternStr= '^.{'+vm.model.minLength +',}$';
            minPattern = new RegExp(minPatternStr);     
            setAriaLabelOnLoad(vm.model.enableAriaLabel);      
            setFocus("new_password");
    });     
   };
 
   function validateRegEx(pattern, val)
   {
      return pattern.test(val);
   };
   
   function setVisibility(result, element)
   {
       if (result)
       {
        element.classList.add("glyphicon-one-fine-ok");
        element.classList.remove("glyphicon-one-fine-dot");
       }
       else
       {
        element.classList.add("glyphicon-one-fine-dot");
        element.classList.remove("glyphicon-one-fine-ok");
       }
   };
   
   function setAriaLabelOnLoad(enable)
   {
       var element = document.getElementById('new_password');
       if (enable)
       {
          var arialDescriptionText = vm.data['changepassword.form.title'] + ". " + vm.data['changepassword.form.instruction'];
           if (vm.model.hasMinLength)
           {
               arialDescriptionText = arialDescriptionText + vm.data['changepassword.form.validaterule_has_min_length']  + ". ";
           }
           if (vm.model.hasLowerCase)
           {
               arialDescriptionText = arialDescriptionText + vm.data['changepassword.form.validaterule_has_lower_case'] + ". ";
           }
           if (vm.model.hasUpperCase)
           {
               arialDescriptionText = arialDescriptionText + vm.data['changepassword.form.validaterule_has_upper_case']  + ". ";
           }
           if (vm.model.hasNumeric)
           {
               arialDescriptionText = arialDescriptionText + vm.data['changepassword.form.validaterule_has_numeric'] + ". ";
           }
           if (vm.model.hasSpecialCharacters)
           {
               arialDescriptionText = arialDescriptionText + vm.data['changepassword.form.validaterule_has_special_characters']  + ". ";
           }

           element.setAttribute('aria-label', arialDescriptionText);
       }
       else
       {
           element.setAttribute('aria-label', '');
       }
   };

   function newPasswordBlur() {
       vm.hasRegExError = false;
       vm.model.hasErrors = false;
       var val = $window.document.getElementById('new_password').value;
       setAriaLabelOnLoad(false);

       // Clear confirm password if user modified the new password
       if (val !== vm.tempNewPasswordValue) {
            $window.document.getElementById("confirm_password").value = "";
                vm.tempNewPasswordValue = $window.document.getElementById("new_password").value;
       }

       if (val !== "")
       {
           displayRegExErrors(val);
       } 
   };

   function validateRules() {
       var val = $window.document.getElementById('new_password').value;
       setVisibility(validateRegEx(minPattern, val),  $window.document.getElementById('imgMinLength'));
       setVisibility(validateRegEx(lowercasePattern, val), $window.document.getElementById('imgLowerCase'));
       setVisibility(validateRegEx(uppercasePattern, val), $window.document.getElementById('imgUpperCase'));
       setVisibility(validateRegEx(numericPattern, val), $window.document.getElementById('imgNumeric'));
       setVisibility(validateRegEx(specialCharacterPattern, val), $window.document.getElementById('imgSpecialChar'));
    };

   function displayRegExErrors(val)
   {
       $window.document.getElementById("confirm_password").value = "";       
       var hasRegExRuleErrors = $window.document.getElementById('regExRuleErrors');
       hasRegExRuleErrors.innerHTML = '';
       var serverSideError = $window.document.getElementById('serverSideError');
       serverSideError.innerHTML = '';
       var error = hasRegExRuleErrors.innerHTML;  

       if (!validateRegEx(minPattern, val) && vm.model.hasMinLength)
       {           
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changepassword.messages.validate_error_min_char'] +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(lowercasePattern, val) && vm.model.hasLowerCase)
       {    
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changepassword.messages.validate_error_lower_case']  +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(uppercasePattern, val) && vm.model.hasUpperCase)
       {
           error =  error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changepassword.messages.validate_error_upper_case']  +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(numericPattern, val) && vm.model.hasNumeric)
       {
           error = error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changepassword.messages.validate_error_numeric'] +'</span><br/>';
           vm.hasRegExError = true;
       }

       if (!validateRegEx(specialCharacterPattern, val) && vm.model.hasSpecialCharacters)
       {
           error = error + '<span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> <span>'+ vm.data['changepassword.messages.validate_error_special_char']  +'</span>';
           vm.hasRegExError = true;
       }

       if (vm.hasRegExError)
       { 
           hasRegExRuleErrors.setAttribute('name', 'passwordConfirm_' + new Date().getTime());
           hasRegExRuleErrors.innerHTML = error;
           setFocus("new_password");
       }
   };

   function confirmPasswordBlur()
   {
        vm.hasConfirmPasswordError = false;
        var confirmValue = $window.document.getElementById('confirm_password').value;
        var newPasswordValue = $window.document.getElementById('new_password').value;
        
        var confirmPasswordErr = $window.document.getElementById('passwordConfirmError');
        if (confirmValue !== '' && confirmValue !== newPasswordValue)
        {
            vm.hasConfirmPasswordError = true;
            confirmPasswordErr.setAttribute('name', 'passwordConfirm_'+ new Date().getTime());
            confirmPasswordErr.innerHTML = vm.data['changepassword.messages.validate_error_invalid_confirm_password'];
            var regExRuleErrors = $window.document.getElementById('regExRuleErrors');
            regExRuleErrors.innerHTML = '';
            var serverSideError = $window.document.getElementById('serverSideError');
            serverSideError.innerHTML = '';
            setFocus("confirm_password");
        }
        else
        {
            confirmPasswordErr.innerHTML = '';
        }
    };

    function setFocus(elementId) {
        // Handle onblur and focus issue on firefox
        setTimeout(function () { 
            $window.document.getElementById(elementId).focus()
        }, 0);
    }
  
}

export default changepasswordController;



// WEBPACK FOOTER //
// ./src/login/changepassword/changepassword.controller.js